import { TextField } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from '~/components/Icon';

function FancyUnitInput({
  onChange,
  value = undefined,
  increment = 0.001,
  decimalPlace = 3,
  maxAmount,
  minAmount,
  ...rest
}) {
  const [localValue, setLocalValue] = useState(value);

  function callOuterOnChange({ event, value }) {
    onChange({
      ...event,
      target: {
        ...event.target,
        value,
      },
    });
  }

  function localOnChange(e) {
    const { value } = e.target;

    const isValueEmptyString = value === '';
    if (isValueEmptyString) {
      setLocalValue(undefined);
      callOuterOnChange({ event: e, value: undefined });
      return;
    }

    const parsedValue = Number(value);
    if (parsedValue < 0) {
      setLocalValue(parseFloat(0).toFixed(decimalPlace));
      callOuterOnChange({ event: e, value: 0 });
      return;
    }

    const displayValue = value
      .replace(/,/g, '.') // Replace commas with dots
      .replace(/[^0-9.]/g, '') // Remove all non-numeric characters except dots
      .replace(/^([^.]*)\.(.*)$/, (_, beforeDot, afterDot) => {
        return `${beforeDot}.${afterDot.replace(/\./g, '')}`; // Remove extra dots
      });

    setLocalValue(displayValue);
    const min = typeof minAmount === 'number' ? minAmount : -Infinity;
    const max = typeof maxAmount === 'number' ? maxAmount : Infinity;
    const clampedValue = Math.max(min, Math.min(parsedValue, max));
    callOuterOnChange({ event: e, value: clampedValue });
  }

  function onKeyDownHandler(e) {
    const isUp = e.code === 'ArrowUp';
    const isDown = e.code === 'ArrowDown';
    if (!isUp && !isDown) return;

    e.preventDefault();
    const parsedLocalValue = Number(localValue) || 0;
    localOnChange({
      target: {
        value: isUp
          ? parseFloat(parsedLocalValue + increment).toFixed(decimalPlace)
          : parseFloat(parsedLocalValue - increment).toFixed(decimalPlace),
      },
    });
  }

  return (
    <TextField.Root
      placeholder='0.000'
      onKeyDown={onKeyDownHandler}
      value={localValue}
      onChange={localOnChange}
      {...rest}
    >
      <TextField.Slot>
        <Icon
          name='currency-euro'
          width={14}
          height={14}
          inline
        />
      </TextField.Slot>
    </TextField.Root>
  );
}

FancyUnitInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  isMetric: PropTypes.bool,
  unit: PropTypes.string,
  increment: PropTypes.number,
  decimalPlace: PropTypes.number,
  value: PropTypes.number,
  minAmount: PropTypes.number,
  maxAmount: PropTypes.number,
  width: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FancyUnitInput;
